module.exports = __webpack_public_path__ + "img/tour-39.effa6dd9.png";